import { CMSResource } from "app/resources/cmsresource";
import { HeaderBarLinkResource } from "app/models/HeaderBarLinkResource";

export class HeaderBarLinkListResource extends CMSResource {

	headerBarLinkListResource: HeaderBarLinkResource[];

}